import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, DashboardModule, FormField, Text,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import { getRelatedEntityOwnerOrSubject } from '@functions/relatedEntity'
import { taskTypeSettings } from '@functions/taskListItem'

import useSelector from '@hooks/useSelector'

import useTaskListItem from '@hooks/useTaskListItem'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/TaskDetail'

import Connections from './Connections'
import Overview from './Overview'
import Template from './Template'

interface DetailsProps {
  taskListItemPayload: ReturnType<typeof useTaskListItem>,
}

const Details = (props: DetailsProps) => {
  const {
    taskListItemPayload: {
      callbacks: {
        createOrEditTaskListItem,
        setupTemplateTestingEntities,
      },
      taskListItem,
      taskListItem: { description, task_type, title },
    },
  } = props

  // @ts-expect-error TS2345
  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteRelatedEntity,
    },
  } = pageContext

  const entities = useSelector(reduxState => reduxState.entities)

  const templatePage = getRelatedEntityOwnerOrSubject({
    entities,
    filters: {
      'data.template_type': 'new',
    },
    // @ts-expect-error TS2741
    item: taskListItem,
    returnType: 'subject',
    subjectType: 'TemplatePage',
  })

  // @ts-expect-error TS7053
  const { icon, label: taskTypeLabel } = taskTypeSettings[task_type] || {}

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Box fontSize="small">
          {icon && (
            <Text color="lightGrey" marginRight="small">
              <FontAwesomeIcon icon={icon} />
            </Text>
          )}

          <Text color="lightGrey">
            {taskTypeLabel}
          </Text>
        </Box>
      )}
      title={title || 'Loading...'}
    >
      <Overview callbacks={{ createOrEditTaskListItem }} taskListItem={taskListItem} />

      <Box flexDirection="column" padding="large">
        {!!description && (
          <FormField boxProps={{ marginBottom: 'large' }} label="Description">
            <Box fontSize="small" lineHeight="1.3" padding="large" variant="white" style={{ whiteSpace: 'pre-wrap' }}>
              {description}
            </Box>
          </FormField>
        )}

        <Box>
          <Template
            // @ts-expect-error TS2322
            callbacks={{ deleteRelatedEntity, setupTemplateTestingEntities }}
            entities={entities}
            taskListItem={taskListItem}
            templatePage={templatePage}
          />

          {/*
           // @ts-expect-error TS2322 */}
          <Connections callbacks={{ deleteRelatedEntity }} taskListItem={taskListItem} />
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default Details
